



























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'dayjs';
@Component
export default class ChartBrief extends Vue {
  @Prop() private data!: any;
  @Prop() private intervalTime!: any;
}
